import {
  INICIALITZAR,
  INTRODUCCIO_OBTENIR_DADES
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const fenofases = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
      return action.payload && action.payload.fenofases
        ? action.payload.fenofases
        : {};

    default:
      return state;
  }
};

export default fenofases;
